var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84242 9.66158L21.7598 4.5523L16.8253 2.52513C16.6168 2.43954 16.3832 2.43954 16.1747 2.52513L4.32275 7.39406L9.84242 9.66158Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9777 5.46484L12.0566 10.5726L16.4999 12.398L28.6772 7.39544L23.9777 5.46484Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6439 13.8962L10.8213 11.9151V15.6662C10.8213 16.1389 10.438 16.5221 9.96533 16.5221C9.49263 16.5221 9.10938 16.1389 9.10938 15.6662V11.2118L3.5542 8.92969V23.9981C3.5542 24.3452 3.7638 24.6579 4.08489 24.7898L15.6439 29.5384V13.8962Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.3555 13.8962V29.5384L28.9145 24.7898C29.2355 24.658 29.4452 24.3452 29.4452 23.9981C29.4452 23.4221 29.4452 9.56015 29.4452 8.92969L17.3555 13.8962Z",
    fill: "#DCDCDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.cf6424ae4246afcfe7aef638e08333c8.svg";
export { ForwardRef as ReactComponent };